import { ReactElement, ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import { useSessionExpired } from '~/src/hooks/useSessionExpired';

import { DefaultScreenSkeleton } from './DefaultScreenSkeleton';

type Props = {
  children?: ReactNode;
  isAccessible: boolean;
  loading: boolean;
};

/**
 * Conditionally renders a route if accessible, otherwise redirects to "/"
 * Shows a skeleton when loading or when the session has expired
 * This prevents the user from being redirected to "/" before the session-expired modal appears.
 */
export const EntitlementRouteWrapper = ({
  children,
  isAccessible,
  loading,
}: Props): ReactElement => {
  const { sessionExpired } = useSessionExpired();

  if (loading || sessionExpired) return <DefaultScreenSkeleton />;
  if (!isAccessible) return <Navigate to="/" />;
  return <>{children}</>;
};
